import classNames from "classnames"

import { Label2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"
import { theme } from "@bounce/theme"
import { isInStorybook } from "@bounce/util"
import { useMediaQuery } from "@bounce/web-components"

import type { StoreSliderProps } from "./StoreSlider"
import { StoreRatingSecondary } from "../Store/StoreRatingSecondary/StoreRatingSecondary"

type NearbyStorageSpot = StoreSliderProps["stores"][number]

type StoreSliderCardTagsProps = {
  isOpen: boolean
  statusText: string
  nextStatusTime: string | null
  store: NearbyStorageSpot
  overflowStatus: boolean
}

export const StoreSliderCardTags = ({
  isOpen,
  statusText,
  nextStatusTime,
  store,
  overflowStatus,
}: StoreSliderCardTagsProps) => {
  const { t } = useTranslation()
  const isSmallMobile = useMediaQuery(`(max-width: ${theme.spacing("screen-xs")}px)`)
  const isReviewCountVisible = !isSmallMobile || overflowStatus || isInStorybook()
  const nextStatusTimeText =
    nextStatusTime === "24/7" ? t("cmp.storeSlider.card.nextStatusTime.247", "24/7") : nextStatusTime

  return (
    <div className="flex items-center justify-between gap-2">
      <div
        className={classNames("rounded-full px-2 py-1 text-sm", {
          "bg-green-200": isOpen,
          "bg-red-200": !isOpen,
          "border-2 border-white": overflowStatus,
        })}>
        <Label2 className="mr-1 !font-bold">{statusText}</Label2>
        {!!nextStatusTime && <Label2 className="!font-medium text-neutral-800">{nextStatusTimeText}</Label2>}
      </div>
      <div
        className={classNames("rounded-full px-2 py-1 text-sm", {
          "bg-gray-100": store.rating,
        })}>
        <StoreRatingSecondary store={store} isReviewCountVisible={isReviewCountVisible} />
      </div>
    </div>
  )
}
